// §11.5 / §9.1 — the Store as an in-process app.
//
// Installing is a shell act (§9.4: "what no app can ever do" ends with "install another app"), so
// it is handed a `StoreShellAccess` at composition (D-059) rather than reaching for the kernel.
import { createRoot, type Root } from 'react-dom/client';
import type { InProcessApp, StoreShellAccess } from '@hangar/shared';
import { Store } from './Store';
import './store.css';

const roots = new WeakMap<HTMLElement, Root>();

export function createStoreApp(access: StoreShellAccess): InProcessApp {
  return {
    id: 'store',
    name: 'Store',
    icon: { glyph: 'store', hue: 295 },
    keywords: ['install', 'apps', 'catalog', 'add', 'flightdeck', 'marketplace'],
    window: { width: 820, height: 620, minWidth: 480, minHeight: 400 },

    mount(container, api) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Store api={api} access={access} />);
    },

    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
